import React from 'react';
import {EmailInputElement} from 'types/documentTemplateElement';
import {DocumentTemplate} from '../../../types/documentTemplate';
import BaseInputProperties from './BaseInputProperties';

interface EmailInputPropertiesProps {
  element: EmailInputElement;
  template: DocumentTemplate;
  updateElement: (updatedElement: EmailInputElement) => void;
}

const EmailInputProperties: React.FC<EmailInputPropertiesProps> = ({
  element,
  template,
  updateElement,
}) => {
  return (
    <BaseInputProperties
      element={element}
      template={template}
      updateElement={updateElement}
    />
  );
};

export default EmailInputProperties;
